<nb-layout>
  <nb-layout-header fixed>
    <app-header></app-header>
  </nb-layout-header>
    <nb-sidebar tag="left"  class="left"  [compactedBreakpoints]="['xs', 'is', 'sm']" [collapsedBreakpoints]="['xs', 'is', 'sm']" responsive>
        <nb-menu  [items]="menuItems"></nb-menu>
    </nb-sidebar>
   <nb-layout-column>
    <div class="container">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>
  </nb-layout-column>
  <nb-layout-footer>
    <app-footer></app-footer>
  </nb-layout-footer>
</nb-layout>
